import { render, staticRenderFns } from "./typeModel.vue?vue&type=template&id=35c92271"
import script from "./typeModel.vue?vue&type=script&lang=js"
export * from "./typeModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c92271')) {
      api.createRecord('35c92271', component.options)
    } else {
      api.reload('35c92271', component.options)
    }
    module.hot.accept("./typeModel.vue?vue&type=template&id=35c92271", function () {
      api.rerender('35c92271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/typeManage/typeModel.vue"
export default component.exports